var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-chart"},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":require("@/assets/images/no-data.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t("el.common.noData")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }